import { Component, ViewChild } from '@angular/core'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import { UserServiceResources as us } from 'se-resource-types'
import { RemovePersonaModalComponent } from '../../lib/remove-persona-modal/remove-persona-modal.component'

const exampleHtml = `
<button (click)="modal.open(persona)">Remove Persona</button>
<se-po-remove-persona-modal #modal (personaRemoved)="onPersonaRemoved($event)"></se-po-remove-persona-modal>
`

const exampleTypescript = `
import { Component, ViewChild } from '@angular/core'
import { UserServiceResources as us } from 'se-resource-types'
import { RemovePersonaModalComponent } from '../../lib/remove-persona-modal/remove-persona-modal.component'

export class RemovePersonaModalExampleComponent {
  @ViewChild('modal') public modal: RemovePersonaModalComponent

  public persona = {
    id: 5,
    first_name: 'Carl',
    last_name: 'McMansion',
    date_of_birth: '2000-01-21',
    gender: 'male',
    graduation_year: '2020',
    email_addresses: [{ address: 'test@test.com', is_primary: true, id: 10, enabled: true }] as us.PersonaEmailAddress[],
    type: 'self'
  } as us.Persona

  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]

  public onPersonaRemoved(persona: us.Persona): void {
    console.log(\`Persona \${persona.first_name} \${persona.last_name} destroyed\`)
  }
}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-remove-persona-modal-example',
  template,
  styleUrls: ['./remove-persona-modal-docs.component.scss'],
  standalone: false,
})
export class RemovePersonaModalExampleComponent extends SeFeDocsExampleComponent {
  @ViewChild('modal') public modal: RemovePersonaModalComponent

  public persona = {
    id: 5,
    first_name: 'Carl',
    last_name: 'McMansion',
    date_of_birth: '2000-01-21',
    gender: 'male',
    graduation_year: '2020',
    email_addresses: [{ address: 'test@test.com', is_primary: true, id: 10, enabled: true }] as us.PersonaEmailAddress[],
    type: 'self'
  } as us.Persona

  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]

  constructor() {
    super()
  }

  public onPersonaRemoved(persona: us.Persona): void {
    console.log(`Persona ${persona.first_name} ${persona.last_name} destroyed`)
  }


}
